import clsx from 'clsx';
import { Loading } from '@linktivity/link-ui';
import styles from './loader.module.css';

const Loader = ({ className = '' }) => {
  return (
    <div className={clsx(styles.loading, className)}>
      <Loading />
    </div>
  );
};
export default Loader;
